var map = {
	"./arrow-back.vue": [
		97946,
		7946
	],
	"./arrow-down.vue": [
		23009,
		3009
	],
	"./arrow-up.vue": [
		30908,
		908
	],
	"./cancelled.vue": [
		48726,
		8726
	],
	"./card-skew-background.vue": [
		5027,
		5027
	],
	"./chevron-down.vue": [
		50429,
		429
	],
	"./chevron-up.vue": [
		63212,
		3212
	],
	"./clock.vue": [
		56810,
		6810
	],
	"./close.vue": [
		90239,
		2620
	],
	"./ended.vue": [
		14627,
		4627
	],
	"./final-time.vue": [
		67789,
		7789
	],
	"./football-arbitrage.vue": [
		45226,
		5226
	],
	"./football-ball-vector.vue": [
		50487,
		487
	],
	"./football-miss.vue": [
		69702,
		9702
	],
	"./football-own-goal.vue": [
		92179,
		2179
	],
	"./football-score-check.vue": [
		79053,
		9053
	],
	"./football-score.vue": [
		28228,
		8228
	],
	"./football-substitution-short-in.vue": [
		35796,
		5796
	],
	"./football-substitution-short-out.vue": [
		59131,
		9131
	],
	"./football-substitution.vue": [
		72381,
		4762
	],
	"./football-var.vue": [
		59947,
		9947
	],
	"./full-time-clock.vue": [
		24919,
		4919
	],
	"./game-statistics.vue": [
		28148,
		8148
	],
	"./goal.vue": [
		89675,
		9675
	],
	"./info.vue": [
		52789,
		2789
	],
	"./jersey-set/jersey-basic.vue": [
		66590,
		4209
	],
	"./jersey-set/jersey-horizontal-stripes.vue": [
		50532,
		532
	],
	"./jersey-set/jersey-split.vue": [
		80669,
		669
	],
	"./jersey-set/jersey-squares.vue": [
		36669,
		6669
	],
	"./jersey-set/jersey-vertical-stripes.vue": [
		21345,
		1345
	],
	"./key-moments.vue": [
		66903,
		6903
	],
	"./latest-close.vue": [
		66771,
		6771
	],
	"./live-indicator.vue": [
		64136,
		1755
	],
	"./mozzart-logo.vue": [
		48441,
		8441
	],
	"./no-data-icon.vue": [
		25672,
		5672
	],
	"./player-avatar.vue": [
		61663,
		1663
	],
	"./player-profile-bio.vue": [
		21636,
		1636
	],
	"./player-profile-form.vue": [
		97469,
		7469
	],
	"./player-profile-match.vue": [
		62440,
		2440
	],
	"./player-profile-transfer.vue": [
		9358,
		9358
	],
	"./red.vue": [
		39888,
		9888
	],
	"./service-unavailable.vue": [
		35881,
		5881
	],
	"./soccer-bet-logo.vue": [
		48136,
		5019
	],
	"./substitute-in.vue": [
		39911,
		9911
	],
	"./substitute-out.vue": [
		84649,
		4649
	],
	"./team-profile-fixtures.vue": [
		28214,
		8214
	],
	"./team-profile-team.vue": [
		12620,
		239
	],
	"./tennis-movement-down.vue": [
		56599,
		6599
	],
	"./tennis-movement-up.vue": [
		44527,
		4527
	],
	"./venue.vue": [
		80756,
		756
	],
	"./whistle.vue": [
		61350,
		1350
	],
	"./yellow-red-card.vue": [
		75747,
		5747
	],
	"./yellow-red.vue": [
		54331,
		4331
	],
	"./yellow.vue": [
		57930,
		7930
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 70538;
module.exports = webpackAsyncContext;